[
  {
    "state": "Alabama",
    "abbreviation": "Ala.",
    "code": "AL"
  },
  {
    "state": "Alaska",
    "abbreviation": "Alaska",
    "code": "AK"
  },
  {
    "state": "Arizona",
    "abbreviation": "Ariz.",
    "code": "AZ"
  },
  {
    "state": "Arkansas",
    "abbreviation": "Ark.",
    "code": "AR"
  },
  {
    "state": "California",
    "abbreviation": "Calif.",
    "code": "CA"
  },
  {
    "state": "Colorado",
    "abbreviation": "Colo.",
    "code": "CO"
  },
  {
    "state": "Connecticut",
    "abbreviation": "Conn.",
    "code": "CT"
  },
  {
    "state": "Delaware",
    "abbreviation": "Del.",
    "code": "DE"
  },
  {
    "state": "District of Columbia",
    "abbreviation": "D.C.",
    "code": "DC"
  },
  {
    "state": "Florida",
    "abbreviation": "Fla.",
    "code": "FL"
  },
  {
    "state": "Georgia",
    "abbreviation": "Ga.",
    "code": "GA"
  },
  {
    "state": "Hawaii",
    "abbreviation": "Hawaii",
    "code": "HI"
  },
  {
    "state": "Idaho",
    "abbreviation": "Idaho",
    "code": "ID"
  },
  {
    "state": "Illinois",
    "abbreviation": "Ill.",
    "code": "IL"
  },
  {
    "state": "Indiana",
    "abbreviation": "Ind.",
    "code": "IN"
  },
  {
    "state": "Iowa",
    "abbreviation": "Iowa",
    "code": "IA"
  },
  {
    "state": "Kansas",
    "abbreviation": "Kans.",
    "code": "KS"
  },
  {
    "state": "Kentucky",
    "abbreviation": "Ky.",
    "code": "KY"
  },
  {
    "state": "Louisiana",
    "abbreviation": "La.",
    "code": "LA"
  },
  {
    "state": "Maine",
    "abbreviation": "Maine",
    "code": "ME"
  },
  {
    "state": "Maryland",
    "abbreviation": "Md.",
    "code": "MD"
  },
  {
    "state": "Massachusetts",
    "abbreviation": "Mass.",
    "code": "MA"
  },
  {
    "state": "Michigan",
    "abbreviation": "Mich.",
    "code": "MI"
  },
  {
    "state": "Minnesota",
    "abbreviation": "Minn.",
    "code": "MN"
  },
  {
    "state": "Mississippi",
    "abbreviation": "Miss.",
    "code": "MS"
  },
  {
    "state": "Missouri",
    "abbreviation": "Mo.",
    "code": "MO"
  },
  {
    "state": "Montana",
    "abbreviation": "Mont.",
    "code": "MT"
  },
  {
    "state": "Nebraska",
    "abbreviation": "Nebr.",
    "code": "NE"
  },
  {
    "state": "Nevada",
    "abbreviation": "Nev.",
    "code": "NV"
  },
  {
    "state": "New Hampshire",
    "abbreviation": "N.H.",
    "code": "NH"
  },
  {
    "state": "New Jersey",
    "abbreviation": "N.J.",
    "code": "NJ"
  },
  {
    "state": "New Mexico",
    "abbreviation": "N.M.",
    "code": "NM"
  },
  {
    "state": "New York",
    "abbreviation": "N.Y.",
    "code": "NY"
  },
  {
    "state": "North Carolina",
    "abbreviation": "N.C.",
    "code": "NC"
  },
  {
    "state": "North Dakota",
    "abbreviation": "N.D.",
    "code": "ND"
  },
  {
    "state": "Ohio",
    "abbreviation": "Ohio",
    "code": "OH"
  },
  {
    "state": "Oklahoma",
    "abbreviation": "Okla.",
    "code": "OK"
  },
  {
    "state": "Oregon",
    "abbreviation": "Ore.",
    "code": "OR"
  },
  {
    "state": "Pennsylvania",
    "abbreviation": "Pa.",
    "code": "PA"
  },
  {
    "state": "Rhode Island",
    "abbreviation": "R.I.",
    "code": "RI"
  },
  {
    "state": "South Carolina",
    "abbreviation": "S.C.",
    "code": "SC"
  },
  {
    "state": "South Dakota",
    "abbreviation": "S.D.",
    "code": "SD"
  },
  {
    "state": "Tennessee",
    "abbreviation": "Tenn.",
    "code": "TN"
  },
  {
    "state": "Texas",
    "abbreviation": "Tex.",
    "code": "TX"
  },
  {
    "state": "Utah",
    "abbreviation": "Utah",
    "code": "UT"
  },
  {
    "state": "Vermont",
    "abbreviation": "Vt.",
    "code": "VT"
  },
  {
    "state": "Virginia",
    "abbreviation": "Va.",
    "code": "VA"
  },
  {
    "state": "Washington",
    "abbreviation": "Wash.",
    "code": "WA"
  },
  {
    "state": "West Virginia",
    "abbreviation": "W.Va.",
    "code": "WV"
  },
  {
    "state": "Wisconsin",
    "abbreviation": "Wis.",
    "code": "WI"
  },
  {
    "state": "Wyoming",
    "abbreviation": "Wyo.",
    "code": "WY"
  }
]
